import React, { PureComponent } from 'react';
import { arrayOf, oneOfType, node } from 'prop-types';
import styled from 'styled-components';

import Link from './WrappedLink';
import { getUser, logOut } from '../utils/persist';
import { APP_ENV, ROLES } from '../utils/constants';
import { hasRole } from '../utils/general';

export default class Navbar extends PureComponent {
  static propTypes = {
    children: oneOfType([arrayOf(node), node]),
  };

  state = {
    name: '',
    otherRoles: [],
  };

  componentDidMount() {
    const user = getUser();

    const otherRoles = user.roles.filter((role) => role !== ROLES.USER_MANAGER);
    this.setState({
      name: user.name,
      otherRoles,
    });
  }

  handleRedirect = (appPath) => () => {
    window.location.href = `/${appPath}`;
  };

  render() {
    return (
      <nav className="navbar" aria-label="main navigation">
        <div className="navbar-brand">
          <Link className="navbar-item brand-text" to="/admin/users">
            <img src="/login/logo-speed-bianco.svg" alt="logo"/>
            {APP_ENV !== 'prod' ? <Env>{APP_ENV}</Env> : ''}
          </Link>
          <div className="navbar-burger burger" data-target="navMenu">
            <span/>
            <span/>
            <span/>
          </div>
        </div>
        <div className="navbar-menu">
          <div className="navbar-end">
            {this.props.children}
            <a className="navbar-item dropdown is-hoverable is-right mar-right-20">
              <div className="dropdown-trigger is-flex">
                <i className="mi mi-account-circle" style={{ marginRight: 8 }}/>
                <p>{this.state.name}</p>
              </div>
              <div className="dropdown-menu" id="dropdown-menu6" role="menu">
                <div className="dropdown-content">
                  <ul>
                    {hasRole('cms') && (
                      <li
                        className="dropdown-item"
                        onClick={this.handleRedirect('cms')}
                      >
                        <p>CMS</p>
                      </li>
                    )}
                    {hasRole('booking') && (
                      <li
                        className="dropdown-item"
                        onClick={this.handleRedirect('booking')}
                      >
                        <p>Booking</p>
                      </li>
                    )}
                    {hasRole('marketing') && (
                      <li
                        className="dropdown-item"
                        onClick={this.handleRedirect('marketing')}
                      >
                        <p>Marketing</p>
                      </li>
                    )}
                    {hasRole('user-manager') && (
                      <li
                        className="dropdown-item"
                        onClick={this.handleRedirect('admin/users')}
                      >
                        <p>Utenti</p>
                      </li>
                    )}
                    {hasRole('report') && (
                      <li
                        className="dropdown-item"
                        onClick={this.handleRedirect('report')}
                      >
                        <p>Report</p>
                      </li>
                    )}
                    {hasRole('super-admin') && (
                      <li
                        className="dropdown-item"
                        onClick={this.handleRedirect('logs')}
                      >
                        <p>Logs</p>
                      </li>
                    )}
                    <Separator />
                    <li className="dropdown-item" onClick={logOut}>
                      <p>Logout</p>
                    </li>
                  </ul>
                </div>
              </div>
            </a>
          </div>
        </div>
      </nav>
    );
  }
}

const Env = styled.span`
  text-transform: capitalize;
`;

const Separator = styled.hr`
  margin: 0;
`;
